import React, {useState} from "react";
import mainlogo from '../assets/images/hagnostechlogo.webp';
import chlogo from '../assets/images/htnewlogo1.webp';
import { Link } from "react-router-dom";
import dashboardicon from '../assets/images/sidebar/Dashboard.webp';
import { useLocation } from 'react-router-dom';
import { faLinkedinIn, faSquareFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faArrowUpRightDots, faBlog, faComment, faNewspaper } from "@fortawesome/free-solid-svg-icons";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from 'react-redux';
import { faUser, faFlag } from '@fortawesome/free-solid-svg-icons';
import { faMessage } from '@fortawesome/free-solid-svg-icons';
import { faChartLine , faHome, faGear} from '@fortawesome/free-solid-svg-icons';
const Sidebar = () => {
  const [selectedindex, setselectedindex] = useState(0);
//   const userdata = useSelector((store) => store.userReducer.userdata)
    var navdata = [
        // {name: 'Dashboard', icon: faChartSimple, activeicon: faChartSimple, route: 'dashboard', access: ['superadmin', 'admin']},
    {name: 'Dashboard', icon: faHome , activeicon: faLinkedinIn, route: 'dashboard', access: ['superadmin', 'admin']},
  
    {name: 'Campaigns', icon: faFlag  , activeicon: faLinkedinIn, route: 'campaigntest', access: ['superadmin', 'admin']},
    {name: 'Posts', icon: faMessage  , activeicon: faLinkedinIn, route: 'all-posts', access: ['superadmin', 'admin']},
    // {name: 'Images', icon: faImage  , activeicon: faImage, route: 'media-gallery', access: ['superadmin', 'admin']},
      {name: 'Reports', icon: faChartLine , activeicon: faLinkedinIn, route: 'reports', access: ['superadmin', 'admin']},
   
     {name: 'Social Media Login', icon: faUser , activeicon: faSquareFacebook, route: 'platformlogin', access: ['superadmin', 'admin']},
    // {name: 'Linkedin', icon: faLinkedinIn , activeicon: faLinkedinIn, route: 'linkedin', access: ['superadmin', 'admin']},
    // {name: 'instagram', icon: faInstagram , activeicon: faInstagram, route: 'instagram', access: ['superadmin', 'admin']},
   
    // {name: 'User', icon: faUser, activeicon: faUser, route: 'user', access: ['superadmin', 'admin']},
    {name: 'Settings', icon: faGear, activeicon: faGear, route: 'settings', access: ['superadmin', 'admin']},
     
     ];
    const location = useLocation();
    console.log('location.pathname >>>', location.pathname);
    return (
        <div className="sidebarmaindiv">
            {/* <img src={mainlogo} className="sidebarlogo" /> */}
            <img src={chlogo} className="sidebarlogo" />
            <div className="sidebarnavmaindiv">
                {navdata?.map((item, index) => {
                //   if(item?.access?.includes(userdata?.type)) {
                    var mainclass = "sidebarnavrow";
                    var iconname = item?.icon;
                    if(location.pathname == "/admin/"+item.route) {
                        mainclass = "sidebarnavrow active";
                        iconname = item?.activeicon;
                    }
                    return (
                      <Link
                        to={"/admin/" + item.route}
                        className={mainclass}
                        key={index}
                        onClick={() => {
                          setselectedindex(index);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item?.icon}
                        //   fontSize={19}
                          className="sidebarnavicon"
                          style={{
                            marginLeft: 15,
                            cursor: "pointer",
                          }}
                        />
                        <p className="shoppingtext">{item.name}</p>
                      </Link>
                    );
                //   }
                   
                })}
                
            </div>
        </div>
    )
}

export default Sidebar